import { IncentivizeRewardsDto, UserSpoolDto } from '../../../../types/spool-local';
import { formatUSD } from '../../../../helpers/formats';
import Button from '../../../Button';

type Props = {
    incentivizedRewards: IncentivizeRewardsDto[];
    userSpool: UserSpoolDto | undefined;
    claimRewards: () => void;
};

const IncentivizedRewards: React.FC<Props> = ({
    incentivizedRewards,
    userSpool,
    claimRewards,
}) => {
    const hasClaimableBalance = userSpool?.userIncentivizedRewards?.reduce(
        (total, { claimableAmount }) => (total += +claimableAmount),
        0
    );

    return (
        <div className='incentivized-rewards'>
            <span>Your Incentivized Rewards</span>

            {incentivizedRewards.length ? (
                <>
                    <div className='tokens'>
                        {userSpool?.userIncentivizedRewards?.length
                            ? userSpool.userIncentivizedRewards
                                  .filter(({ isRemoved }) => !isRemoved)
                                  .map(({ claimableAmount, token }) => (
                                      <div key={token.id} className='amount'>
                                          {formatUSD(claimableAmount || 0)}{' '}
                                          {token.symbol ?? 'XXX'}
                                      </div>
                                  ))
                            : incentivizedRewards
                                  .filter(({ isRemoved }) => !isRemoved)
                                  .map(({ symbol, id }) => (
                                      <div key={id} className='amount'>
                                          0.00 {symbol ?? 'XXX'}
                                      </div>
                                  ))}
                    </div>
                    <Button
                        disabled={
                            !userSpool?.userIncentivizedRewards?.length ||
                            !hasClaimableBalance
                        }
                        onClick={claimRewards}
                        variant='secondary'
                    >
                        Claim Rewards
                    </Button>
                </>
            ) : (
                <div className='tokens'>
                    <div className='amount '>N/A</div>
                </div>
            )}
        </div>
    );
};

export default IncentivizedRewards;
